//--------- Info modules
import mTotalCnt   from './sub/urDataGridInfoModuleTotalCnt.vue';
import mPerPage    from './sub/urDataGridInfoModulePerPage.vue';
import mRowActBtn  from './sub/urDataGridInfoModuleRowActButton.vue';
import mCellActBtn from './sub/urDataGridInfoModuleCellActButton.vue';
import mSelCnt     from './sub/urDataGridInfoModuleSelectedCnt.vue';


const CLZ_INFO_ROW  = 'ur-data-grid__info-row';
const CLZ_INFO_AREA = 'ur-data-grid__info-area';
const CLZ_ACT_ROW   = 'ur-data-grid__action-row';
const CLZ_ACT_AREA  = 'ur-data-grid__action-area';

export default {
    name : "urDataGridInfo",
    inject : ['gridInfo'],
    computed : {
        // [COMPUTED] Flag, Info 영역 여부
        isInfo() {return !this.gridInfo.opts.noInfo},
        // [COMPUTED] Flag, Action 영역 여부
        isAction() {
            /*/ 1. Row edit
            if(this.gridInfo.opts.rowEdit) {
                // 1.x Pagination? CUD button -> action row
                return !!this.gridInfo.opts.pagination;
            }
            // 2. Cell edit
            if(this.gridInfo.opts.cellEdit) {
                // 2.x Pagination? CUD button -> action row
                return !!this.gridInfo.opts.pagination;
            }/**/
            // 3. Slot
            if( !!this.gridInfo.slot['left-action'] ||
                    !!this.gridInfo.slot['right-action']) {
                return true;
            }
            return false;
        },
    },
    methods: {
        // [METHOD] Build-Info, Build left info area
        buildLeftInfo(h) {
            var rtn = [];
            const OPTS = this.gridInfo.opts
                , SLOT_KEY = 'left-info';
            // 1. build modules
            // 1.- Default modules
            if( !OPTS.rightInfo && (!OPTS.noBaseInfo || !this.gridInfo.slot[SLOT_KEY])) {
                // 1.1 Total Count
                rtn.push(h(mTotalCnt));
                // 1.2 Pagination
                if(OPTS.pagination)  {rtn.push(h(mPerPage))}
                // 1.3 Selected text
                if(OPTS.multiSelect) {rtn.push(h(mSelCnt))}
                // 1.4 Edit buttons
                if(OPTS.rowEdit)     {rtn.push(h(mRowActBtn))}
                // 1.5 Edit buttons - cell
                if(OPTS.cellEdit)    {rtn.push(h(mCellActBtn))}
            }
            // 1.6 Slot
            this.buildSlot(h, rtn, SLOT_KEY)
            // x. Return result
            return rtn;
        },
        // [METHOD] Build-Info, Build center info area
        buildCenterInfo(h){
            var rtn = [];
            // 1. Build modules
            this.buildSlot(h, rtn,'center-info')
            // x. Return result
            return rtn;
        },
        // [METHOD] Build-Info, Build right info area
        buildRightInfo(h) {
            var rtn = [];
            const OPTS = this.gridInfo.opts
                , SLOT_KEY = 'right-info';
            // 1. Build modules
            // 1.1 Slot
            this.buildSlot(h, rtn, SLOT_KEY)
            // 1.- Default modules
            if( OPTS.rightInfo && (!OPTS.noBaseInfo || !this.gridInfo.slot[SLOT_KEY])) {
                // 1.2 Edit buttons - row
                if(OPTS.rowEdit)     {rtn.push(h(mRowActBtn))}
                // 1.2 Edit buttons - cell
                if(OPTS.cellEdit)    {rtn.push(h(mCellActBtn))}
                // 1.3 Selected text
                if(OPTS.multiSelect) {rtn.push(h(mSelCnt))}
                // 1.4 Pagination
                if(OPTS.pagination)  {rtn.push(h(mPerPage))}
                // 1.5 Total Count
                rtn.push(h(mTotalCnt));
            }
            // x. Return result
            return rtn;
        },
        // [METHOD] Build-Action, Build right action area
        buildLeftAction(h) {
            var rtn = [];
            // 1. Build modules
            this.buildSlot(h, rtn,'left-action')
            // x. Return result
            return rtn;
        },
        // [METHOD] Build-Action, Build right action area
        buildRightAction(h) {
            var rtn = [];
            // 1. Build modules
            this.buildSlot(h, rtn,'right-action')
            // x. Return result
            return rtn;
        },
        // [METHOD] Util, Check slot & build, append
        buildSlot(h, arr, slotName) {
            const SLOT = this.gridInfo.slot;
            if(SLOT[slotName]) {
                arr.push(h('div',{'class':'ur-data-grid__info-item ur-data-grid__info-item--slot'},[
                    SLOT[slotName](this.__slotScoped())
                ]));
            }
        },
        // [METHOD] Util, get "SLOT-SCOPED" for build slot
        __slotScoped() {
            return {gridInfo:this.gridInfo};
        }
    },
    render(h) {
        if(this.gridInfo.opts.noInfo) {return null;}
        // 0. Prepare value
        let rows = [];
        // 1. Info area
        if(this.isInfo) {
            // 1.1 Left info
            var hLeftInfo   = this.buildLeftInfo(h);
            // 1.2 Center info
            var hCenterInfo = this.buildCenterInfo(h);
            // 1.3 Right info
            var hRightInfo  = this.buildRightInfo(h);
            // 1.x Build info row
            rows.push(h('div',{'class':CLZ_INFO_ROW}, [
                h('div',{'class':[CLZ_INFO_AREA,'ur-data-grid__info__left'  ]}, hLeftInfo),
                h('div',{'class':[CLZ_INFO_AREA,'ur-data-grid__info__center']}, hCenterInfo),
                h('div',{'class':[CLZ_INFO_AREA,'ur-data-grid__info__right' ]}, hRightInfo),
            ]))
        }
        // 1. Info area
        if(this.isAction) {
            // 1.1 Left info
            var hLeftAction  = this.buildLeftAction(h);
            // 1.2 Right info
            var hRightAction = this.buildRightAction(h);
            // 1.x Build info row
            rows.push(h('div',{'class':CLZ_ACT_ROW}, [
                h('div',{'class':[CLZ_ACT_AREA,'ur-data-grid__action__left' ]}, hLeftAction),
                h('div',{'class':[CLZ_ACT_AREA,'ur-data-grid__action__right']}, hRightAction),
            ]))
        }
        // x. Render template
        return h('div',{'class':'ur-data-grid__info'}, rows)
    }
}
